<template>
  <div>
    <MainNavigation :routeIndex="routeIndex"/>
    <NotificationBar
      msg-text="Select the “Add Class” button to set up your first class."
    />
    <div>
      <h3>My Classes</h3>
      <p>Set up your first class here:</p>
      <button @click="this.$router.push({ name: 'new-class' })">
        Add Class
      </button>
    </div>
  </div>
</template>

<script>
import MainNavigation from "../components/MainNavigation.vue";
import NotificationBar from "../components/NotificationBar.vue";
export default {
  name: "AddClass",
  components: {
    MainNavigation,
    NotificationBar,
  },
  props: ["routeIndex"]
};
</script>

<style>
</style>